import * as React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@mui/material/styles';
import { ToggleButton, ToggleButtonGroup, Paper } from '@mui/material';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
        margin: theme.spacing(0.5),
        border: 0,
        '&.Mui-disabled': {
            border: 0,
        },
        '&:not(:first-of-type)': {
            borderRadius: 20,
        },
        '&:first-of-type': {
            borderRadius: 20,
        },
        '&.MuiToggleButton-root': {
            paddingTop: '3px',
            paddingBottom: '3px',
            textTransform: 'none',
        },
    },
}));

export default function QuestionTypeSwitch({ onChange, selected = 'professional', counts = {} }) {
    const [type, setType] = React.useState(selected);
    const { formatMessage } = useIntl();

    const handleType = (event, newType) => {
        setType(newType);
        onChange(newType);
    };

    const profText = `${formatMessage({ id: 'Questions.referenceType.professional' })} (${counts.professional ?? 0})`;
    const personalText = `${formatMessage({ id: 'Questions.referenceType.personal' })} (${counts.personal ?? 0})`;
    const academicText = `${formatMessage({ id: 'Questions.referenceType.academic' })} (${counts.academic ?? 0})`;
    const candidateText = `${formatMessage({ id: 'Questions.referenceType.candidate' })} (${counts.candidate ?? 0})`;

    return (
        <div>
            <Paper
                elevation={0}
                sx={{
                    display: 'flex',
                    border: (theme) => `1px solid ${theme.palette.divider}`,
                    borderRadius: '50px !important',
                    flexWrap: 'wrap',
                }}
            >
                <StyledToggleButtonGroup
                    size="small"
                    color="primary"
                    value={type}
                    exclusive
                    onChange={handleType}
                    aria-label="text alignment"
                >
                    <ToggleButton value="professional" aria-label="professional">
                        {profText}
                    </ToggleButton>
                    <ToggleButton value="personal" aria-label="personal">
                        {personalText}
                    </ToggleButton>
                    <ToggleButton value="academic" aria-label="academic">
                        {academicText}
                    </ToggleButton>
                    <ToggleButton value="candidate" aria-label="candidate">
                        {candidateText}
                    </ToggleButton>
                </StyledToggleButtonGroup>
            </Paper>
        </div>
    );
}
